<template>
<div class="chapter">
<div class="inner_page">
<h1 class="heading">1<br/><em class="italic">April 1913</em></h1>
<p class="firstparagraph"><span class="dropcap">R</span>unning on the beach. Chaotic noises, busy. A call; a male voice shouting in the wind. The sound of something happening in the surf.</p>
<p class="basic-paragraph">It was a dream perhaps, or perhaps a memory leaching out. Such a sweet dream though. ‘Ship-O! . . . <em class="italic">Napps</em> . . . Are you there? Are you all well?’</p>
<p class="basic-paragraph">A glimmer of consciousness brought him back into the overturned dinghy. He remembered Everland as a colour, an immense blackness, where the cycle of time had dilated to a single endless night. But to permit even a fraction of wakefulness was to suffer. The pain was monstrous. Think of God, if at all. </p>
<p class="basic-paragraph">He heard digging. Snow was being shovelled away from the dinghy’s buried sides. </p>
<p class="basic-paragraph">‘We have him! We have one of them!’</p>
<p class="basic-paragraph">A burst of activity surrounded him as men crawled into the dinghy. His arms were clenched around his head, covering his face, and they talked in low whispers, afraid to touch him.</p>
<p class="basic-paragraph">Someone said tentatively, ‘Is he alive?’ </p>
<p class="basic-paragraph">‘I don’t know, I can’t tell. Where’s the doctor? Hurry, <em class="italic">get Addison.</em>’</p>
<p class="basic-paragraph">Boots pelted off across the shingle. </p>
<p class="basic-paragraph">‘Napps? . . . Millet-Bass? . . . ’ Men were searching the beach and yells echoed from every direction. ‘Any sign?’ they called to each other.</p>
<p class="basic-paragraph">Addison arrived and knelt close. ‘Can you hear me?’ he said, leaning down to talk to Dinners directly. ‘We’re taking you back to the ship. Can you hear me, Dinners?’ </p>
<p class="basic-paragraph"> Then he asked for assistance from those nearby. ‘Be very careful, on my instruction. Very, very careful, this will hurt him. So easy does it. All hands ready?’</p>
<p class="basic-paragraph">In agony, Dinners moaned and ground his teeth as they lifted him on to a stretcher. He was carried to the shoreline and passed over to men on a boat. Oars drove against the ice-crusted waves. </p>
<p class="basic-paragraph">‘It’s all right, we’re here and we’ve found you now,’ Addison said when Dinners looked up at him and started to cry. </p>
<p class="basic-paragraph">The gratitude was overpowering. Dinners cried for the miracle of being found He cried for not being driven out of his collapsing body and made to die alone in the cold. And he cried for Napps and Millet-Bass; for the heartbreak and the pity of what had come before.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// everland_00001.vue?6165204f